// Stored comment HTML only keeps href on links (server-sanitized), so the
// new-tab behaviour is added at render time instead of being persisted.
export const openLinksInNewTab = (html: string): string => {
  const template = document.createElement('template');
  template.innerHTML = html;

  template.content.querySelectorAll('a[href]').forEach(link => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });

  return template.innerHTML;
};
